import EventOutputsTable from './EventOutputsTable.container';

export default EventOutputsTable;
